import React, {useEffect, useState} from "react";
import styled from "styled-components";
import Table from "../../components/table";
import {selPolicyTerms} from "../../services/platform/ManageUserAxios";
import {columnTermData} from "./entity/common";
import PlatformSectionHeader from "./PlatformSectionHeader";
import PlatformTableBody from "./PlatformTableBody";
import {useNavigate} from "react-router-dom";

export default function PlatformTerm(){
  const navigate=useNavigate();
  const [terms,setTerms]=useState([]);
  useEffect(()=>{selPolicyTerms().then(response=>setTerms(Array.isArray(response)?response:[]));},[]);
  const openDetail=(...args)=>{
    const event=args.find(arg=>arg?.target||arg?.nativeEvent?.target);
    const target=event?.target||event?.nativeEvent?.target;
    if(target?.closest?.("button,a,input,select,[role='button']")) return;
    const row=args.find(arg=>arg?.data && typeof arg.data==="object")?.data;
    if(row?.id) navigate("/board/platformTermDetail",{state:{id:row.id}});
  };
  return <Page>
    <Card>
      <PlatformSectionHeader title="조회 조건" description="현재 등록된 전체 약관을 기준으로 목록을 조회합니다."/>
    </Card>
    <Card>
      <PlatformSectionHeader title="약관 목록" description="등록된 약관의 유형과 적용 정보를 확인합니다." count={terms.length} unit="건"/>
      <PlatformTableBody><Table columns={columnTermData} data={terms} onRowClick={openDetail}/></PlatformTableBody>
    </Card>
  </Page>;
}
const Page=styled.div`display:flex;width:100%;flex-direction:column;gap:16px;`;
const Card=styled.section`overflow:hidden;border:1px solid var(--color-border);border-radius:10px;background:var(--color-surface);box-shadow:0 5px 18px rgba(31,41,55,.045);`;
